import $models from '@/models'
import moment from "@/moment-gp";
import { ENABLE_AUTO_HIDE_BACKLOG } from "@/features"
//import clonedeep from "lodash.clonedeep";

// ------------------------------------------------------------------------------------------------
function dayplanFindTimeslotFlexible({
  remaining_timeslots,
  duration_remaining,
  magic_timeslot_from,
  magic_timeslot_to
}) {

  // const log0 = (...args) => console.log("%c[dayplanFindTimeslot:Flexible]", "color: #b4692d; background-color: #e0e0e0", ...args);
  const log0 = () => {}

  log0('dayplanFindTimeslotFlexible INPUT magic_timeslot_to:', magic_timeslot_to)
  log0('dayplanFindTimeslotFlexible INPUT magic_timeslot_from:', magic_timeslot_from)

  let from = magic_timeslot_from;

  for ( let i = 0; i < remaining_timeslots.length; i++ ) {

    let timeslot = remaining_timeslots[i]
    log0('durationPlanning timeslot', timeslot, from >= timeslot.from, from <= timeslot.to)

    if (from >= timeslot.from && from <= timeslot.to) {
      log0('durationPlanning mode A timeslot duration:',
        i, timeslot.to - timeslot.from,
        moment(1000 * timeslot.from).format(),
        moment(1000 * timeslot.to).format())

      log0('durationPlanning A:', timeslot.to, 'B', from + duration_remaining, 'C', magic_timeslot_to)

      let to = Math.min(timeslot.to, from + duration_remaining, magic_timeslot_to)
      log0('durationPlanning to:', moment(to * 1000).format())

      if (to - from > 0) {
        log0('durationPlanning mode A adding item in timeslot ', i, moment(1000 * timeslot.from).format(), moment(1000 * timeslot.to).format())

        return {
          from: from,
          to: to,
          duration:  to - from,
          sortidx: (timeslot.sortidxTo + timeslot.sortidxFrom ) / 2,
          devTimeslotId: i,
          devMarker: 'A'
        };
      }
    } else if (from < timeslot.from) {

      log0('durationPlanning mode 2')
      let to = Math.min(timeslot.to, timeslot.from + duration_remaining, magic_timeslot_to)

      if (to - timeslot.from > 0) {
        log0('durationPlanning mode B adding item in timeslot ', i, timeslot, moment(1000 * timeslot.from).format(), moment(1000 * timeslot.to).format())
        return {
          from: timeslot.from,
          to: to,
          duration:  to - timeslot.from,
          sortidx: (timeslot.sortidxTo + timeslot.sortidxFrom ) / 2,
          devTimeslotId: i,
          devMarker: 'B'
        };
      }
    }
  }
  return { duration: 0 };
}

export default {

  // ------------------------------------------------------------------------------------------------
  setDragItem({ commit }, item) {
    //console.log('setDragItem', item)
    if (item && item.from && item.to && !item.dragConfig) {
      //let newItem = clonedeep(item)
      let data = {
        dragConfig: {
          duration: item.to - item.from,
          shiftingEnabled: true,
          //minFrom ... earliest start date
          //maxTo ... latest end date
          //minDuration: val.to - val.from,
          placeAtEnd: false
        }
      }
      Object.assign(item, data)
    } else if (item && item.duration && !item.dragConfig) {
      let data = {
        dragConfig: {
          duration: item.duration,
          shiftingEnabled: true,
          //minFrom ... earliest start date
          //maxTo ... latest end date
          //minDuration: val.to - val.from,
          placeAtEnd: false
        }
      }
      Object.assign(item, data)
    }
    commit('SET_DRAG_ITEM', item);
  },

  setDragItemType({ commit }, val) {
    // console.log('setDragItemType', val)
    commit('SET_DRAG_ITEM_TYPE', val);
  },

  setDragTargetDate({ commit }, val) {
    //console.log('setDragTargetDate', val)
    commit('SET_DRAG_TARGET_DATE', val);
  },

  setDragTargetIndex({ commit }, val) {
    //console.log('setDragTargetIndex', val)
    commit('SET_DRAG_TARGET_INDEX', val);
  },

  setDragActive({ commit }, val) {
    commit('SET_DRAG_ACTIVE', val);
  },

  setDragTimeActive({ commit }, val) {
    commit('SET_DRAG_TIME_ACTIVE', val);
  },

  setDragTimeSelection({ commit }, val) {
    commit('SET_DRAG_TIME_SELECTION', val);
  },

  setDragTimeOffset({ commit }, val) {
    commit('SET_DRAG_TIME_OFFSET', val);
  },

  // ------------------------------------------------------------------------------------------------
  setBacklogStatus({ commit }, { sessionId, status }) {
    if ( status ) {
      if ( ENABLE_AUTO_HIDE_BACKLOG ) {
        commit('HIDE_BACKLOG_ALL');
      }
      commit('SHOW_BACKLOG', sessionId );
    } else {
      commit('HIDE_BACKLOG', sessionId );
    }
  },

  // ------------------------------------------------------------------------------------------------
  //createSnapshot({ commit }, dayplan) {
    // TODO: Implemented Undo / Redo

    /*
    log0("** createSnapshot **");

    if (!dayplan) {
      return;
    }

    if (dayplan.nonUserUpdate) {
      delete dayplan.nonUserUpdate;
      return;
    }

    this.snapshot_stack.push(clonedeep(dayplan));

    // Create creating a branch, so emtpy redo stack
    this.snapshot_stack_redo = [];

    // Maximum stack size is 25
    if (this.snapshot_stack.length > 25) {
      this.snapshot_stack.shift();
    }
    */
  //},

  // ------------------------------------------------------------------------------------------------
  initializeDayplanner({ commit }) {
    /*
    this.currentDate = moment.currentDate();
    this.dateTimestamp = this.currentDate
      .clone()
      .startOf("day")
      .unix();
    this.dateString = this.currentDate.format("YYMMDD");
    */

    commit('SET_VIEW_DATE', moment.currentDate().toStore() )
    commit('SELECT_DATE', moment.currentDate().toStore() )
  },

  // ------------------------------------------------------------------------------------------------
  setOptimizerCommitmentCache({ commit, state }, commitmentData) {

    let commitmentDataHashNew = JSON.stringify( commitmentData );

    if ( !commitmentData
       || commitmentData.length === 0
       || commitmentDataHashNew !== state.commitment_data_hash
    ) {
      commit('SET_COMMITMENT_CACHE', {
        data: commitmentData,
        hash: commitmentDataHashNew
      })
    }
  },

  // ------------------------------------------------------------------------------------------------
  /*
  * dayplanFindTimeslot - finds an empty timeslot in the dayplan
  * mode can be 'fixed' or 'flexible'
  *
  */
  dayplanFindTimeslot({ commit, getters, dispatch }, {
    magicTimeslotFrom,
    magicTimeslotTo,
    durationRemaining,
    mode = "flexible"
  } = {}) {

    /* TODO options: - plan from early to late,
                     - plan from late to early
                     - defined in each TSC
    */

    // console.log('durationPlanning input', magicTimeslotFrom, durationRemaining, mode, getters.dayplan_remaining_timeslots)

    if ( mode === "flexible" ) {
      return dayplanFindTimeslotFlexible({
        remaining_timeslots: getters.dayplan_remaining_timeslots,
        duration_remaining:  durationRemaining,
        magic_timeslot_from:  magicTimeslotFrom,
        magic_timeslot_to:    magicTimeslotTo,
      });
    }
  },

  // ------------------------------------------------------------------------------------------------
  debugReset({ commit, getters, dispatch }) {

    //dispatch('createSnapshot', getters.dayplan_from_db);

    //this.dayplan = [];
    getters.dayplan_from_db.forEach(session => {
      let timeoutDistance = 0;
      setTimeout(() => {
        $models.userDayplannerSessions.remove(session.sessionId);
      }, timeoutDistance);
      timeoutDistance += 10;
    });
  }
}
